import { Skeleton } from '@/components/ui/skeleton';

/**
 * Loading placeholder for one summary card. Mirrors the real `StatCard` DOM (same padding,
 * gaps, icon box, two stat rows, and meter) so its height matches a loaded card exactly — a
 * single hardcoded pixel height would drift as the card content changes.
 */
export const SummaryCardSkeleton = () => (
  <div className="flex h-full flex-col gap-4 rounded-lg bg-muted p-4">
    <div className="flex items-center gap-2">
      <Skeleton className="h-8 w-8 shrink-0 rounded-md" />
      <Skeleton className="h-5 w-32" />
    </div>
    <div className="flex flex-1 flex-col gap-2">
      <div className="flex items-center justify-between">
        <Skeleton className="h-4 w-24" />
        <Skeleton className="h-4 w-12" />
      </div>
      <div className="flex items-center justify-between">
        <Skeleton className="h-4 w-20" />
        <Skeleton className="h-4 w-10" />
      </div>
      <div className="mt-auto flex flex-col gap-1.5">
        <Skeleton className="h-2 w-full rounded-full" />
        <div className="flex items-center justify-between">
          <Skeleton className="h-3 w-20" />
          <Skeleton className="h-3 w-20" />
        </div>
      </div>
    </div>
  </div>
);
